var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10.5V12.75C17.25 15.6495 14.8995 18 12 18C9.10052 18 6.75002 15.6495 6.75002 12.75V10.5H5.25002V12.75C5.24102 16.1902 7.83002 19.0815 11.25 19.4528V21H8.25002V22.5H15.75V21H12.75V19.4557C16.164 19.071 18.7455 16.1858 18.75 12.75V10.5H17.25Z",
    fill: "url(#paint0_linear_545_10409)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 5.25C9.75 4.00725 10.7573 3 12 3C13.2428 3 14.25 4.00725 14.25 5.25V12.75C14.25 13.9928 13.2428 15 12 15C10.7573 15 9.75 13.9928 9.75 12.75V5.25ZM12 16.5C14.07 16.4978 15.7477 14.82 15.75 12.75V5.25C15.75 3.17925 14.0707 1.5 12 1.5C9.92925 1.5 8.25 3.17925 8.25 5.25V12.75C8.25225 14.82 9.93 16.4978 12 16.5Z",
    fill: "url(#paint1_linear_545_10409)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_545_10409",
    x1: 5.57143,
    y1: 10.4152,
    x2: 18.5097,
    y2: 23.2875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B6AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77D9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_545_10409",
    x1: 8.42857,
    y1: 1.39399,
    x2: 20.3922,
    y2: 6.68401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B6AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77D9CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.e8f114a7b260fed4f895289e2517a101.svg";
export { ForwardRef as ReactComponent };